import * as React from 'react';
const CheckSaveIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    fill='#000000'
    width='800px'
    height='800px'
    viewBox='0 0 1920 1920'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M1743.858 267.012 710.747 1300.124 176.005 765.382 0 941.387l710.747 710.871 1209.24-1209.116z'
      fillRule='evenodd'
    />
  </svg>
);
export default CheckSaveIcon;
